if (!customElements.get('u-counter')) {
  customElements.define(
    'u-counter',
    class UCounter extends HTMLElement {
      constructor() {
        super();

        this.counterNumbers = this.querySelectorAll('.counter-number');
      }

      connectedCallback() {
        const animateCounter = (element) => {
          const target = parseInt(element.getAttribute('data-target'));
          const duration = 1000; // 2 seconds
          const increment = target / (duration / 16); // 60fps
          let current = 0;

          const timer = setInterval(() => {
            current += increment;
            if (current >= target) {
              current = target;
              clearInterval(timer);
            }
            element.textContent = Math.floor(current).toLocaleString();
          }, 16);
        };

        // Intersection Observer for animation on scroll
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && !entry.target.classList.contains('animated')) {
                entry.target.classList.add('animated');
                animateCounter(entry.target);
              }
            });
          },
          { threshold: 0.5 }
        );

        this.counterNumbers.forEach((counter) => {
          observer.observe(counter);
        });
      }
    }
  );
}
